var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"dark":"","color":"grey darken-2"}},[_c('div',{staticClass:"my-4"},[_c('p',{staticClass:"title mb-0"},[_vm._v("Submitify")]),_c('p',{staticClass:"body-1 mb-0"},[_vm._v("by Levi Rizki Saputra")])])])}
var staticRenderFns = []

export { render, staticRenderFns }